<template>
  <!-- Add coursework popup -->
  <vs-card
    style="background: #fff; position: relative"
    class="cstm_vx_card p-4"
    v-if="addCoursework"
    :class="{ show: addCoursework }"
  >
    <div
      slot="header"
      style="border-bottom: 1px solid rgba(0, 0, 0, 0.2)"
      class="flex flex-wrap justify-between items-center pb-5 mb-4"
    >
      <h4>{{ fileType }}</h4>
      <button @click.stop="closePopupNoteModal" class="cc-close-modal">
        &times;
      </button>
    </div>
    <div>
      <div
        class="flex flex-wrap justify-between items-center mb-4"
        v-if="!addNewCoursework"
      >
        <h5>{{ fileType }} List</h5>

        <vs-tooltip text="Add New" color="primary">
          <vs-button
            type="border"
            color="primary"
            icon="add"
            @click="addNewCoursework = true"
          />
        </vs-tooltip>
      </div>

      <div
        v-if="addNewCoursework"
        style="max-height: 50vh; overflow: auto"
        class="vertical_scrollbar"
      >
        <CourseOrExam
          :type="fileType"
          :assignment_type="fileType == 'Coursework' ? 2 : 4"
          :course_subject_ids="course_subject_ids"
          :has_course_all_subject="has_course_all_subject"
          @closeCreateModal="closeCreateModal"
        />
      </div>
      <div
        v-if="topic_list.length > 0 && !addNewCoursework"
        style="max-height: 300px; overflow: auto"
        class="vertical_scrollbar border_btm pb-4"
        @scroll="detectsScrollLength()"
        ref="element"
      >
        <vs-table
          style="max-height: 300px"
          class="cstm_vuexy_table vertical_scrollbar"
          :data="topic_list"
        >
          <template slot="thead">
            <vs-th></vs-th>
            <vs-th>Name</vs-th>
            <vs-th>Description</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td
                ><input
                  type="radio"
                  name="picked"
                  class="cursor-pointer"
                  @click="selectFile(data[indextr])"
              /></vs-td>
              <vs-td :data="data[indextr].title">
                {{ data[indextr].title }}
              </vs-td>
              <vs-td :data="data[indextr].description">
                {{ data[indextr].description }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <vs-button class="block mx-auto mt-6" @click="exportToCourse()"
        >Export to Coursebuilder</vs-button
      >
      <!--  <div v-else class="flex flex-col justify-center items-center my-6">
        <img
          src="https://scoolio-files.s3.ap-south-1.amazonaws.com/Scoolio/no_coursework.png"
          alt="nodata"
        />
        <p class="text-center">No Coursework found</p>
      </div> -->
    </div>
  </vs-card>
</template>
<script>
import CourseOrExam from './AddCourseOrExam.vue'
export default {
  props: {
    addCoursework: {
      default: false
    },
    fileType: {
      default: ''
    },
    topic_list: {
      default: []
    },
    course_subject_ids: {
      type: Array,
      require: false,
      default: []
    },
    has_course_all_subject: {
      type: Boolean,
      require: false,
      default: true
    }
  },
  components: {
    CourseOrExam
  },
  data () {
    return {
      selected: [],
      addNewCoursework: false
    }
  },
  methods: {
    selectFile (data) {
      this.selected = data
    },
    detectsScrollLength () {
      if (
        Math.ceil(
          this.$refs.element.scrollTop + this.$refs.element.offsetHeight
        ) >= this.$refs.element.scrollHeight
      ) {
        this.$emit('loadMoreTopicCourse', this.fileType)
      }
    },
    closeCreateModal () {
      this.addNewCoursework = false
      this.$emit('updatefetchTopic', this.fileType)
    },
    closePopupNoteModal () {
      this.$emit('closeModal', true)
    },
    exportToCourse () {
      const topic_type = this.fileType === 'Coursework' ? 3 : 4
      this.$emit('exportToCourse', this.selected, topic_type)
    }
  }
}
</script>

<style>
.cc-close-modal {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  background-color: #fff;
  padding: 8px;
  cursor: pointer;
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  font-size: 1.75em;
  color: rgba(0, 0, 0, 0.6);
  border: none;
  z-index: 10000;
}
</style>